import { Divider } from '../layout/divider.js'

export const DndDivider = () => (
  <Divider sx={{ borderWidth: 2, borderColor: theme => theme.vars.palette.primary.main }} />
)

export default DndDivider
